import {IError} from '../helpers/types';
import {LARAVEL_REQUIRED_BY_FIELD} from './contactFormMessages';

const LARAVEL_VALIDATION_MESSAGES: Record<string, string> = {
    'validation.unique': 'Такое значение уже занято',
    'validation.required': 'Обязательное поле',
    'validation.email': 'Некорректный email',
    'validation.min.string': 'Слишком короткое значение',
    'validation.min.numeric': 'Значение слишком маленькое',
    'validation.max.string': 'Слишком длинное значение',
    'validation.max.numeric': 'Значение слишком большое',
    'validation.confirmed': 'Подтверждение не совпадает',
    'validation.string': 'Некорректное значение',
    'validation.integer': 'Введите целое число',
    'validation.numeric': 'Введите число',
    'validation.exists': 'Выбранное значение некорректно',
    'validation.in': 'Выбранное значение некорректно',
    'validation.regex': 'Некорректный формат',
};

const UNIQUE_BY_FIELD: Record<string, string> = {
    email: 'Такой email уже зарегистрирован',
    phone: 'Такой телефон уже зарегистрирован',
    login: 'Такой логин уже зарегистрирован',
    inn: 'Такой ИНН уже зарегистрирован',
};

const LARAVEL_KEY_RE = /^validation\./;

export const mapLaravelValidationMessage = (raw: unknown, fieldName?: string): string => {
    const msg = Array.isArray(raw) ? raw[0] : raw;
    if (typeof msg !== 'string' || msg.trim() === '') {
        return 'Ошибка валидации';
    }

    if (msg === 'validation.required') {
        return (fieldName && LARAVEL_REQUIRED_BY_FIELD[fieldName]) || LARAVEL_VALIDATION_MESSAGES[msg];
    }

    if (msg === 'validation.unique') {
        return (fieldName && UNIQUE_BY_FIELD[fieldName]) || LARAVEL_VALIDATION_MESSAGES[msg];
    }

    if (LARAVEL_VALIDATION_MESSAGES[msg]) {
        return LARAVEL_VALIDATION_MESSAGES[msg];
    }

    if (LARAVEL_KEY_RE.test(msg)) {
        return 'Ошибка валидации';
    }

    return msg;
};

/** Тост/errorReq: Laravel кладёт первую ошибку в `message`. */
export const mapLaravelErrorPayload = (data: unknown): IError => {
    if (!data || typeof data !== 'object') {
        return {message: 'Ошибка запроса', errors: {}};
    }

    const payload = data as {message?: unknown; errors?: unknown};
    // Auth API иногда возвращает строку errors: её нельзя индексировать как карту полей.
    const errors: Record<string, unknown> = payload.errors && typeof payload.errors === 'object' && !Array.isArray(payload.errors)
        ? payload.errors as Record<string, unknown>
        : {};
    const firstField = Object.keys(errors)[0];
    const fromField = firstField
        ? mapLaravelValidationMessage(errors[firstField], firstField)
        : undefined;
    const fromTop = mapLaravelValidationMessage(payload.message);

    return {
        message: fromField || fromTop || 'Ошибка запроса',
        errors,
    };
};
